import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AxiosCommonError } from '../../../../../../../shared/types';
import { handleError } from '../../../../../../ui/err/handleError';

import { aiAgentApis } from '../../../../../../../shared/apis/ai-agent/apis';

export default function usePutManualPresignedUrl() {
  return useMutation(aiAgentApis.manual.getManualPresignedUrl, {
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
